module.exports = __webpack_public_path__ + "img/logo-white.ea56cd71.png";